<template>
    <div class="nf-table nf-bg-fff nf-padding-10 box-bg-style">
        <nf-edit-table
            :is-edit-table.sync="isEditTable"
            :table-head-list="listData.tableHeadList"
            :store-model-name="storeModelName"
        />
        <el-row
            type="flex"
            justify="space-between"
            align="middle"
            class="top-operation"
        >
            <el-col class="title">
                <el-button
                    v-if="addBtnLink"
                    :size="$store.state.element.elBtnSize"
                    icon="el-icon-plus"
                    type="primary"
                    @click="handleToAddClick"
                >
                    {{ addBtnLinkText }}
                </el-button>
                <slot name="top-btn-left" />
            </el-col>
            <el-col v-if="$slots['top-btn-right'] && $slots['top-btn-right'][0].children.length || importUrl || isExportBtn">
                <el-row
                    type="flex"
                    justify="end"
                    align="middile"
                >
                    <slot name="top-btn-right" />
                    <el-button
                        v-if="importUrl"
                        :size="$store.state.element.elBtnSize"
                        icon="el-icon-upload2"
                    >
                        导入
                    </el-button>
                    <el-button
                        v-if="isExportBtn"
                        :size="$store.state.element.elBtnSize"
                        icon="el-icon-download"
                    >
                        导出
                    </el-button>
                </el-row>
            </el-col>
        </el-row>
        <div
            v-show="listData.tableHeadList.length"
            class="table-wrap"
        >
            <el-table
                ref="nfTable"
                :data="listData.list"
                :summary-method="getSummaries"
                tooltip-effect="dark"
                style="width: 100%"
                :height="elTableHeight?elTableHeight:tableHeight"
                stripe
                border
                size="mini"
                row-key="id"
                lazy
                :load="load"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                :show-summary="showSummary"
                :header-cell-style="{background:'#f5f5f5',color:'#333'}"
                @row-click="handleRowClick"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    v-if="isTableSelect"
                    type="selection"
                    width="55"
                />
                <el-table-column
                    v-for="(item, index) in newTableHeadList"
                    :key="index"
                    :fixed="item.fixed"
                    :min-width="item.width?item.width:item.label.length*14+44"
                    show-overflow-tooltip
                    :sortable="item.sortable?false:true"
                >
                    <template slot="header">
                        {{ item.label }}
                    </template>
                    <template slot-scope="scope">
                        <!-- 追加插槽 -->
                        <div v-if="item.slotName">
                            <slot
                                :scope="scope.row"
                                :name="item.slotName"
                            />
                        </div>
                        <span
                            v-else
                            class="ellipsis"
                            v-text="scope.row[item.prop]"
                        />
                    </template>
                </el-table-column>

                <!-- :width="item.width?item.width:item.label.length*14+44" -->
                <el-table-column
                    v-if="rightButtons.length>0"
                    :fixed="isOperationFixed?'right':false"
                    :width="operationWidth"
                >
                    <template slot="header">
                        <span>操作</span>
                        <el-button
                            v-if="isEditTableBtn"
                            type="text"
                            class="setting-btn"
                            icon="el-icon-setting"
                            @click="isEditTable=true"
                        />
                    </template>
                    <template slot-scope="scope">
                        <el-row
                            type="flex"
                            class="operation-box"
                        >
                            <div
                                v-for="(item, index) in rightButtons"
                                :key="index"
                            >
                                <div v-if="rightButtons.length<=3">
                                    <el-button
                                        v-if="Object.prototype.toString.call(item) === '[object Function]' "
                                        v-show="!item(scope).isHide"
                                        type="text"
                                        :size="$store.state.element.elBtnSize"
                                        :icon="item(scope).icon"
                                        @click="item(scope).click(scope)"
                                    >
                                        {{ item(scope).name }}
                                    </el-button>

                                    <el-button
                                        v-else
                                        v-show="!item.isHide"
                                        type="text"
                                        :size="$store.state.element.elBtnSize"
                                        :icon="item.icon"
                                        @click="item.click(scope)"
                                    >
                                        {{ item.name }}
                                    </el-button>
                                </div>
                                <div v-else>
                                    <div v-if="index<2">
                                        <el-button
                                            v-if="Object.prototype.toString.call(item) === '[object Function]' "
                                            v-show="!item(scope).isHide"
                                            type="text"
                                            :size="$store.state.element.elBtnSize"
                                            :icon="item(scope).icon"
                                            @click="item(scope).click(scope)"
                                        >
                                            {{ item(scope).name }}
                                        </el-button>

                                        <el-button
                                            v-else
                                            v-show="!item.isHide"
                                            type="text"
                                            :size="$store.state.element.elBtnSize"
                                            :icon="item.icon"
                                            @click="item.click(scope)"
                                        >
                                            {{ item.name }}
                                        </el-button>
                                    </div>
                                    <div v-if="index===2">
                                        <el-dropdown trigger="click">
                                            <el-button
                                                type="text"
                                                :size="$store.state.element.elBtnSize"
                                                icon="el-icon-more"
                                            >
                                                更多
                                            </el-button>
                                            <el-dropdown-menu slot="dropdown">
                                                <div
                                                    v-for="(item2, index2) in rightButtons"
                                                    :key="index2"
                                                >
                                                    <div v-if="Object.prototype.toString.call(item) === '[object Function]' ">
                                                        <el-dropdown-item
                                                            v-if="index2>1"
                                                            v-show="!item.isHide"
                                                            :icon="item2(scope).icon"
                                                            @click.native="item2(scope).click(scope)"
                                                        >
                                                            {{ item2(scope).name }}
                                                        </el-dropdown-item>
                                                    </div>
                                                    <div v-else>
                                                        <el-dropdown-item
                                                            v-if="index2>1"
                                                            v-show="!item.isHide"
                                                            :icon="item2.icon"
                                                            @click.native="item2.click(scope)"
                                                        >
                                                            {{ item2.name }}
                                                        </el-dropdown-item>
                                                    </div>
                                                </div>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </div>
                            </div>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
            <el-row
                justify="end"
                type="flex"
                class="pagination-box"
                align="middle"
            >
                <slot name="table-foot" />
                <el-col>
                    <el-checkbox-group
                        v-if="isTableSelect"
                        v-model="checkboxGroup1"
                        :size="$store.state.element.elBtnSize"
                    >
                        <el-checkbox
                            style="margin:0;"
                            label="全选"
                            border
                        />
                        <el-checkbox
                            label="反选"
                            border
                        />
                    </el-checkbox-group>
                </el-col>
                <el-row
                    v-if="isPagination"
                    type="flex"
                    justify="end"
                >
                    <el-pagination
                        background
                        :hide-on-single-page="false"
                        :pager-count="5"
                        :page-sizes="$store.state.element.pageSizes"
                        :page-size="params.size"
                        :layout="paginationLayout"
                        :current-page.sync="params.page"
                        :total="listData.total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    />
                </el-row>
            </el-row>
        </div>
    </div>
</template>
<script>
/** 
 * @author zxm
 * @update 2019年11月26日
 * @module @/commponents/nf-table
 * */

import nfEditTable from '@/components/nf-edit-table/index'
export default {
    name: 'NfTable',
    components: {
        nfEditTable
    },
    props: {
        // 是否显示分页
        isPagination: {
            type: Boolean,
            default: true
        },
        // 导入excel地址
        importUrl: {
            type: String,
            default: ''
        },
        // 导出excel按钮是否显示
        isExportBtn: {
            type: Boolean,
            default: false
        },
        // 多选回调方法
        onTableSelect: {
            type: Function,
            default: () => { }
        },
        // 是否显示表格的多选按钮
        isTableSelect: {
            type: Boolean,
            default: false
        },
        // 添加按钮路由路径
        addBtnLink: {
            type: String,
            default: ''
        },
        // 添加按钮文字
        addBtnLinkText: {
            type: String,
            default: '添加'
        },
        // vuex Model 名称
        storeModelName: {
            type: String,
            required: true,
            default: ''
        },
        // 操作按钮
        rightButtons: {
            type: Array,
            default: () => []
        },
        // 是否显示合计
        showSummary: {
            type: Boolean,
            default: false
        },
        // 是否开启编辑表头功能
        isEditTableBtn: {
            type: Boolean,
            default: true
        },
        // creatd 函数 是否请求列表数据
        isGetList: {
            type: Boolean,
            default: true
        },
        // table的高度
        elTableHeight: {
            type: [Number, String],
            default: 0
        },
        // 组件布局，子组件名用逗号分隔
        paginationLayout: {
            type: String,
            default: 'total,sizes, prev, pager, next'
        },
        // 点击分页监听变化
        onHandleCurrentChange: {
            type: [Function, Boolean],
            default: false
        },
        // 表格 当某一行被点击时会触发该事件
        onTableRowClick: {
            type: [Function, Boolean],
            default: false
        },
        // 树形数据与懒加载 https://element.eleme.cn/#/zh-CN/component/table
        treeLoadFn: {
            type: [Function, Boolean],
            default: false
        },
        // 操作按钮是否固定在右侧浮动
        isOperationFixed: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            // 多选数据
            multipleSelection: [],
            // 记录全选 还是反选
            checkboxGroup1: [],
            // 表头数据
            tableHeadList: [{
                label: '姓名',
                prop: 'name',
                fixed: true,
            }],
            // 列表list数据
            tableDatalist: [{
                name: '1王小虎',
                age: '2'
            }],
            // 是否显示编辑表头 弹出层
            isEditTable: false
        }
    },
    computed: {
        // 新生成的表头数据 过滤表头checked数据
        newTableHeadList () {
            return this.listData.tableHeadList.filter(item => item.checked === 1)
        },
        // table高度
        tableHeight () {
            let h = 0;
            if (!this.addBtnLink && !this.importUrl && !this.isExportBtn) {
                h = 32;
            }
            return this.$store.state.element.tableHeight + h;
        },
        // 获取当前默认页码
        currentPageSize () {
            return this.$store.state.element.currentPageSize;
        },
        // 从store里读取列表数据
        listData () {
            return this.$store.state[this.storeModelName].listData;
        },
        // 列表接口穿参数据
        params () {
            return this.$store.state[this.storeModelName].postParams;
        },
        // 动态计算操作栏宽度
        operationWidth () {

            let sizeNum = 0;
            // 距离左边距离
            let paddingLeftPx = 16;
            // 设置按钮最多显示个数
            let lenMax = 3;
            // 操作按钮实际个数
            let buttonLen = this.rightButtons.length;
            // 最多展示三个按钮 如果大于三个按钮 第三就显示的是更多 所以最大值是3
            let len = buttonLen >= lenMax ? lenMax : buttonLen;
            // 默认盒子宽度
            let defaultBtnWidth = 32;
            // 一个文字的宽度
            let defaultSizeWidth = 13;
            // 遍历计算～
            this.rightButtons.forEach((item, index) => {
                item = item instanceof Function ? item() : item;
                if (index < 2) {
                    sizeNum = sizeNum + item.name.length;
                }
                if (index === 2) {
                    if (buttonLen > lenMax) {
                        sizeNum = sizeNum + 2;
                    } else {
                        sizeNum = sizeNum + item.name.length;
                    }
                }
            });
            // == 左边距+（按钮个数*默认盒子宽度+（文字个数*默认文字宽度））
            return paddingLeftPx + (len * defaultBtnWidth + (sizeNum * defaultSizeWidth));
        },
        // key为列表渲染字端的 tableHeader对象 方便判断当前列 是否使用合集
        tableHeadObj () {
            let obj = {};
            this.newTableHeadList.forEach(item => {
                obj[item.prop] = item;
            });
            return obj
        }

    },
    async created () {
        // init page 
        this.$store.commit(`${this.storeModelName}/updatePostParams`, {
            size: this.currentPageSize
        })
        if (this.isGetList) {
            this.getList();
        }
    },
    // 销毁的时候 清空搜索条件
    destroyed () {
        let params_ = _.cloneDeep(this.params);
        for (let key in params_) {
            params_[key] = '';
        }
        params_.page = 1;

        this.$store.commit(`${this.storeModelName}/updatePostParams`, params_)
    },
    methods: {
        load (tree, treeNode, resolve) {
            if (this.treeLoadFn) {
                this.treeLoadFn(tree, resolve);
            }
            // setTimeout(() => {
            //     resolve([
            //         {
            //             id: 31,
            //             date: '2016-05-01',
            //             name: '王小虎',
            //             address: '上海市普陀区金沙江路 1519 弄'
            //         }, {
            //             id: 32,
            //             date: '2016-05-01',
            //             name: '王小虎',
            //             address: '上海市普陀区金沙江路 1519 弄'
            //         }
            //     ])
            // }, 1000)
        },
        // 调用列表接口
        async getList () {
            this.$store.dispatch(`${this.storeModelName}/getList`);
        },
        // 选择多选
        handleSelectionChange (val) {
            this.multipleSelection = val;
            this.onTableSelect(val);
        },
        // 点击去添加页面
        handleToAddClick () {
            this.$router.push({
                path: this.addBtnLink
            });
        },
        // 选择分页条数
        handleSizeChange (e) {
            this.$store.commit(`${this.storeModelName}/updatePostParams`, {
                size: e,
                page: 1
            })
            this.getList();
        },
        // 切换分页
        handleCurrentChange (e) {
            if (this.onHandleCurrentChange instanceof Function) {
                this.onHandleCurrentChange(e)
            } else {
                this.$store.commit(`${this.storeModelName}/updatePostParams`, {
                    page: e,
                })
                this.getList();
            }
        },
        // 表哥当某一行被点击触发
        handleRowClick (row, column, event) {
            if (this.onTableRowClick instanceof Function) {
                this.onTableRowClick(row, column, event)
            }
        },
        // 合计功能
        getSummaries (param) {

            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (this.tableHeadObj[column.property].summary) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return (prev * 1e5 + curr * 1e5) / 1E5;
                            } else {
                                return prev;
                            }
                        }, 0);
                        // sums[index] += sums[index] ;
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = 'N/A';
                }
            });

            return sums;
        }
    }
}
</script>

<style lang="scss" scoped>
.nf-table {
    margin-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    /deep/.el-table__row {
        height: 34px;
    }
    .el-table {
        transition: all 0.3s;
    }
    .setting-btn {
        font-size: 16px;
        position: absolute;
        right: 0;
        top: 0;
        height: 23px;
        padding: 0 10px;
        color: #737373;
    }
    .title {
        font-size: 14px;
    }
    .top-operation {
        margin-bottom: 10px;
    }
    .pagination-box {
        margin-top: 10px;
    }
    .operation-box {
        button {
            margin-left: 10px;
        }
    }
    /deep/.el-pagination {
        padding-right: 0;
        .btn-next {
            margin-right: 0;
        }
    }
}
</style>


